module.exports = __webpack_public_path__ + "static/media/adobe-xd.0ee1cc59.svg";